import { computed } from 'vue';
import {
  SHOP_MORE_URL_MAP_BY_PROMO_TYPE,
  SHOP_MORE_LABEL_MAP_BY_PROMO_TYPE,
} from '../constants';
import { WITH_CODE } from '../../price/constants';

export const useShopMore = ({
  promoType,
  promoCode,
  categoryUrlWithPromoPlug,
} = {}) => {
  function _getPromoUrlByType() {
    if (promoType.value === WITH_CODE) {
      return SHOP_MORE_URL_MAP_BY_PROMO_TYPE[WITH_CODE]?.replace('[CODE_PLUG]', promoCode.value) || '';
    }

    return SHOP_MORE_URL_MAP_BY_PROMO_TYPE[promoType.value] || '';
  }

  function _getPromoLabelByType() {
    if (promoType.value === WITH_CODE) {
      return SHOP_MORE_LABEL_MAP_BY_PROMO_TYPE[WITH_CODE]?.replace('[CODE_PLUG]', promoCode.value) || '';
    }

    return SHOP_MORE_LABEL_MAP_BY_PROMO_TYPE[promoType.value] || '';
  }

  const label = computed(() => {
    if (!promoType.value) {
      return '';
    }
    return _getPromoLabelByType();
  });

  const url = computed(() => {
    if (!promoType.value || !categoryUrlWithPromoPlug) {
      return '';
    }
    const promoUrl = _getPromoUrlByType();
    return categoryUrlWithPromoPlug.replace('[PROMO_PLUG]', promoUrl);
  });

  return {
    url,
    label,
  };
};

export default useShopMore;
